import type { ComponentType } from 'react';
import type React from 'react';
import { memo } from 'react';

import type { ErrorScreenProps } from '@/js/libs/error-boundary';
import { ErrorBoundary as BaseErrorBoundary } from '@/js/libs/error-boundary';

import ErrorComponent from './Error';

interface ErrorBoundaryProps extends React.PropsWithChildren {
  errorScreenComponent?: ComponentType<ErrorScreenProps>;
}

const DefaultErrorScreenComponent: ComponentType<ErrorScreenProps> = memo(function DefaultErrorScreenComponent({ error }) {
  return <ErrorComponent title={error.message} />;
});

const ErrorBoundary = ({ children, errorScreenComponent = DefaultErrorScreenComponent }: ErrorBoundaryProps) => (
  <BaseErrorBoundary errorScreenComponent={errorScreenComponent}>{children}</BaseErrorBoundary>
);

export default ErrorBoundary;
